import { ReactElement, memo } from "react";
import styled from "styled-components";
import { h } from "../../h";
import { getHours, getMinutes } from "../../utils/date";

const DurationContainerStyled = styled.div`
    display: flex;
`;

const DurationHoursStyled = styled.div``;

const DurationMinutesStyled = styled.div`
    font-size: ${({ theme }) => theme.fontS};
`;

export const DurationView = memo(
    ({ duration }: { duration: number }): ReactElement => {
        return h(
            DurationContainerStyled,
            {},
            h(DurationHoursStyled, {}, getHours(duration)),
            h(DurationMinutesStyled, {}, getMinutes(duration)),
        );
    },
);
